<template>
  <div class="upload-wrapper">
    <a-upload name="avatar" class="avatar-uploader" :customRequest="uploadFun" :show-upload-list="false" :before-upload="beforeUpload" @change="handleChange">
      <a-button type="primary" ghost :loading="loading"> 上传文件 </a-button>
    </a-upload>
    <p class="file-url" v-if="fileUrl">{{ fileUrl }}</p>
  </div>
</template>

<script>
import { uploadFile } from '@/api/caseDetail'
export default {
  model: {
    prop: 'fileUrl',
    event: 'change'
  },
  props: {
    fileUrl: String,
    upText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      fileName: '' // 上传文件的名称
    }
  },
  methods: {
    // 自定义上传方法
    async uploadFun(val) {
      let file = val.file
      const formData = new FormData()
      formData.append('file', file)
      try {
        const res = await uploadFile(formData)
        this.loading = false
        this.fileName = res.data.name
        this.$emit('change', res.data)
        this.$emit('onSuccess', res.data)
      } catch (error) {
        console.log('上传失败')
        this.loading = false
      }
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
      }
      if (info.file.status === 'done') {
        this.loading = false
      }
    },
    beforeUpload(file) {
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.upload-wrapper {
  display: inline-block;
  /deep/ .ant-btn-background-ghost.ant-btn-primary {
    width: 116px;
    height: 32px;
  }
}
</style>
